import { NgModule } from '@angular/core';
import { AuthGuard } from '../core/auth.guard';
import { AuthService } from '../core/auth.service';
import { FirebaseAuthGuard } from './firebase-auth.guard';
import { FirebaseAuthService } from './firebase-auth.service';

@NgModule({
  providers: [
    FirebaseAuthService,
    FirebaseAuthGuard,
    { provide: AuthService, useClass: FirebaseAuthService },
    { provide: AuthGuard, useClass: FirebaseAuthGuard },
  ],
  declarations: [],
  imports: [],
})
export class FirebaseAuthModule { }
